import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { HttpClient } from './http-client';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { DEFAULT_PAGE_SIZE } from './services-constants';

@Injectable()
export class ColaboradoresService {

    constructor(private httpClient: HttpClient,
                private router: Router) {

    }

    getAllColaboradores(page: number = 0){
      return this.httpClient.get(`/api/user/5000/0/`)
         .map((response: Response) => {
           if (response){
             return response.json().ResponseData;
           }
      });
    }

    getColaboradores(page: number = 0){
      return this.httpClient.get(`/api/user/${DEFAULT_PAGE_SIZE}/${page}/`)
         .map((response: Response) => {
           if (response){
             return response.json().ResponseData;
           }
      });
    }

    getColaborador(id: number){
      return this.httpClient.get(`/api/user/${id}`)
         .map((response: Response) => {
           if (response){
             return response.json().ResponseData;
           }
      });
    }

    getEstadisticasColaborador(userId){
      
      return this.httpClient.get(`/api/dashboard/mis-estadisticas/${userId}`)
          .map((response: Response) => {
              return response.json();
          });
    }

    getColaboradoresMiRed(){
      return this.httpClient.get(`/api/user/my-network-rol/`)
         .map((response: Response) => {
           if (response){
             return response.json().ResponseData;
           }
      });
    }

    getActividad(userId: string, page: number = 0){
      return this.httpClient.get(`/api/actividad/user/${userId}/${DEFAULT_PAGE_SIZE}/${page}`)
        .map((response: Response) => {
          return response.json();
        });
    }

    createColaborador(name: string,
                      lastName: string,
                      username: string,
                      jde:string,
                      saf:string,
                      cupos:string,
                      rolesIds,
                      email: string,
                      phoneNumber: string,
                      domicilio: string){
      let request = {
        UserSystemName: username,
        UserName: name,
        UserJDE: jde,
        UserSAF: saf,
        Usu_Usuario_Cupos: cupos,
        UserLastName: lastName,
        UserEmail: email,
        RolIds: rolesIds,
        Telefono: phoneNumber,
        Domicilio: domicilio
      };

      return this.httpClient.post('/api/user/', request)
          .map(( response: Response) => {
              return response;
          });
    }

    editColaborador(
      id: number,
      name: string,
      lastName: string,
      username: string,
      jde:string,
      saf:string,
      cupos:string,
      rolesIds,
      email: string,
      phoneNumber: string,
      domicilio: string)
    {
      let request = {
        UserId: id,
        UserSystemName: username,
        UserName: name,
        UserJDE: jde,
        UserSAF: saf,
        Usu_Usuario_Cupos: cupos,
        UserLastName: lastName,
        UserEmail: email,
        RolIds: rolesIds,
        Telefono: phoneNumber,
        Domicilio: domicilio
      };

      return this.httpClient.put('/api/user/', request)
          .map(( response: Response) => {
              return response;
          });
    }

  getUserJDEAccess() {
    return this.httpClient.get('/api/agris/usuario')
      .map((response: Response) => {
        return response.json().ResponseData;
      });
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/colaboradores-service.ts